import React from "react";
import { motion } from "framer-motion";
import { LuUserCheck, LuSettings, LuUsers, LuClipboardCheck } from "react-icons/lu";
import "./HowItWorksSection.css";

function HowItWorksSection() {
  return (
    <div className="box-how-it-works" id="como-funciona">
      <motion.div
        className="how-it-works"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <h2 className="title-works section-title">¿Cómo Funciona?</h2>
        <motion.ol
          className="content-work"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { staggerChildren: 0.3 } },
          }}
        >
          <motion.li>
            <LuUserCheck /> <strong className="article-title">Registro</strong>
            <p className="article-text">Regístrate como empresa en nuestra plataforma y accede a todas las herramientas necesarias para gestionar traslados corporativos de manera eficiente.</p>
          </motion.li>
          <motion.li>
            <LuSettings /> <strong className="article-title">Configuración</strong>
            <p className="article-text">Configura los servicios de traslado y courier según las necesidades específicas de tu empresa, personalizando detalles clave como horarios y rutas.</p>
          </motion.li>
          <motion.li>
            <LuUsers /> <strong className="article-title">Asignación y Seguimiento</strong>
            <p className="article-text">Asigna servicios a conductores confiables desde nuestra red y realiza un seguimiento en tiempo real para garantizar puntualidad y calidad en cada traslado.</p>
          </motion.li>
          <motion.li>
            <LuClipboardCheck /> <strong className="article-title">Optimización</strong>
            <p className="article-text">Optimiza la gestión con herramientas avanzadas que incluyen historial de servicios, control de pagos, personalización de usuarios, y más.</p>
          </motion.li>
        </motion.ol>
      </motion.div>
    </div>
  );
}

export default HowItWorksSection;
